import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  AccountApi,
  AccountApiGetAccountRequest,
  GetAccount200Response,
  AccountHistoryApi,
  AccountHistoryApiGetAccountHistoriesRequest,
  GetAccountHistories200Response,
} from '@/api/openapi';

export class AccountApiService extends ApiService {
  api = new AccountApi(undefined, this.baseUrl, this.httpInstance);
  historyApi = new AccountHistoryApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getAccount(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<AccountApiGetAccountRequest>,
  ): Promise<AxiosResponse<GetAccount200Response>> {
    return this.checkResponse<GetAccount200Response>(
      this.api.getAccount(request, options),
      errorHandlers,
    );
  }

  async getAccountHistories(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<AccountHistoryApiGetAccountHistoriesRequest>,
  ): Promise<AxiosResponse<GetAccountHistories200Response>> {
    return this.checkResponse<GetAccountHistories200Response>(
      this.historyApi.getAccountHistories(request, options),
      errorHandlers,
    );
  }
}
